import { render, staticRenderFns } from "./PrintPosDteLetter.vue?vue&type=template&id=097c13cb"
import script from "./PrintPosDteLetter.vue?vue&type=script&lang=js"
export * from "./PrintPosDteLetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports